@switch (true) {
  @case (credentialInfo().provider === "LEGIC_CONNECT" || credentialInfo().provider === "HID") {
    <a class="inline-block"
       id="appleButton">
      <img src="/assets/apple_add_to_wallet.svg"
           [alt]="'platform.ios.start' | translate"
           class="h-12 mx-auto"
      />
    </a>
  }
  @case (credentialInfo().provider === "WAVELYNX") {
    @if (redirectTo) {
      <app-redirect [message]="'credential.provider_redirect' | translate"
                    [url]="redirectTo"></app-redirect>
    }
  }
  @default {
    <p class="text-gray-500 font-medium">
      {{ 'credential.provider_unsupported' | translate }}
    </p>
  }
}
